import { mergeModels, useModel, ref, computed, resolveComponent, createElementBlock, openBlock, Fragment, createVNode, unref, isRef, withCtx, createBlock, createCommentVNode, mergeProps } from "vue";
import { WebPageMaker } from "../Pages/index.js";
import _sfc_main$1 from "./BanzaHtmlViewer.vue.js";
import { imgUtils } from "../../plugins/banza/img.js";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useI18n } from "../../plugins/i18n.js";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import { VDialog } from "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import { VCard, VCardText } from "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "./index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import { VWindow, VWindowItem } from "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "vue3-runtime-template";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
const _sfc_main = {
  __name: "HtmlEditor",
  props: /* @__PURE__ */ mergeModels({
    hideTabs: {
      type: Array,
      default: () => [3]
    },
    pageMakerProps: {
      type: Object,
      default: () => ({})
    }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const { t } = useI18n();
    const props = __props;
    const content = useModel(__props, "modelValue");
    const tab = ref("editor");
    const showBetaEditor = ref(false);
    const innerValue = computed({
      get() {
        return imgUtils.findAndReplaceEditorPublicImgUrls(content.value);
      },
      set(val) {
        content.value = val;
      }
    });
    const tabItems = computed(() => {
      const items = [];
      if (isTabVisible(1)) {
        items.push({
          id: "editor",
          name: t("pages.public.edit.editor"),
          iconAttrs: {
            icon: "lets-icons:img-out-box-duotone-line",
            size: "18",
            class: "mr-2",
            color: tab.value !== "editor" ? "rgba(var(--v-theme-toggle-color))" : "white"
          }
        });
      }
      if (isTabVisible(2)) {
        items.push({
          id: "html",
          name: t("pages.public.edit.html"),
          iconAttrs: {
            icon: "lets-icons:news-duotone",
            size: "18",
            class: "mr-2",
            color: tab.value !== "html" ? "rgba(var(--v-theme-toggle-color))" : "white"
          }
        });
      }
      if (isTabVisible(3)) {
        items.push({
          id: "view",
          name: t("pages.public.edit.view"),
          iconAttrs: {
            icon: "lets-icons:eye-duotone",
            size: "18",
            class: "mr-2",
            color: tab.value !== "view" ? "rgba(var(--v-theme-toggle-color))" : "white"
          }
        });
      }
      return items;
    });
    const isTabVisible = (index) => {
      return !props.hideTabs.includes(index);
    };
    const close = () => {
      showBetaEditor.value = false;
    };
    return (_ctx, _cache) => {
      const _component_b_btn_toggle = resolveComponent("b-btn-toggle");
      const _component_b_btn = resolveComponent("b-btn");
      const _component_b_text_edit = resolveComponent("b-text-edit");
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(_component_b_btn_toggle, {
          modelValue: unref(tab),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(tab) ? tab.value = $event : null),
          items: unref(tabItems)
        }, null, 8, ["modelValue", "items"]),
        createVNode(VWindow, {
          modelValue: unref(tab),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => isRef(tab) ? tab.value = $event : null),
          class: "mt-3"
        }, {
          default: withCtx(() => [
            createVNode(VWindowItem, { value: "editor" }, {
              default: withCtx(() => [
                createVNode(VDialog, {
                  modelValue: unref(showBetaEditor),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isRef(showBetaEditor) ? showBetaEditor.value = $event : null),
                  fullscreen: "",
                  "hide-overlay": "",
                  persistent: "",
                  "no-click-animation": ""
                }, {
                  activator: withCtx(({ props: props2 }) => [
                    createVNode(_component_b_btn, mergeProps(props2, {
                      class: "mb-1",
                      preset: "contentEdit"
                    }), null, 16)
                  ]),
                  default: withCtx(() => [
                    createVNode(VCard, {
                      elevation: "0",
                      color: "background",
                      class: "overflow-hidden"
                    }, {
                      default: withCtx(() => [
                        createVNode(VCardText, { class: "pa-0" }, {
                          default: withCtx(() => [
                            unref(showBetaEditor) ? (openBlock(), createBlock(unref(WebPageMaker), mergeProps({
                              key: 0,
                              modelValue: unref(innerValue),
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isRef(innerValue) ? innerValue.value = $event : null)
                            }, __props.pageMakerProps, { onClose: close }), null, 16, ["modelValue"])) : createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            createVNode(VWindowItem, { value: "html" }, {
              default: withCtx(() => [
                createVNode(_component_b_text_edit, {
                  modelValue: unref(innerValue),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => isRef(innerValue) ? innerValue.value = $event : null),
                  "is-multiline": "",
                  "auto-grow": "",
                  outlined: "",
                  density: "compact",
                  rows: "3",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            createVNode(VWindowItem, { value: "view" }, {
              default: withCtx(() => [
                createVNode(_sfc_main$1, {
                  html: unref(innerValue),
                  "is-runtime-template": ""
                }, null, 8, ["html"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 64);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
